export default __webpack_public_path__ + "static/media/info-mine-path.805dc937.svg";